/* eslint-disable promise/always-return */
import loadjs from 'loadjs';
/*
Initializes a YouTube Video Player via the YouTube IFrame API for each element with the 'bt-yt-video' class.

The element should contain, at a minimum, the following data-* attributes:

data-video-id    - The YouTube Video Id
data-video-height - The height (in px) of the video.
data-video-width  - The width (in px) of the video.

Optionally:

data-video-player-vars - JSON string to be parsed and passed to the YouTube Player as the `playerVars` parameter.
                       See also: https://developers.google.com/youtube/player_parameters?playerVersion=HTML5
data-video-player-btn  - A CSS Selector for a play button element that will be setup to start the video (and hide itself) upon click.

*/

loadjs(['https://www.youtube.com/iframe_api'], {
  returnPromise: true,
  async: true
}).then(function () {
  $(function () {
    var playerElementSelector = '.bt-yt-video';
    var yt = window.YT;
    var defaultPlayerVars = {
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      rel: 0
    };
    yt.ready(function () {
      $(playerElementSelector).each(function (idx, el) {
        function initializePlayer() {
          var $el = $(el);
          var playerVars = typeof $el.data('video-player-vars') === 'undefined' ? defaultPlayerVars : JSON.parse($el.data('video-player-vars'));
          var videoId = $el.data('video-id');
          var videoHeight = $el.data('video-height');
          var videoWidth = $el.data('video-width');
          var player = new yt.Player(el, {
            videoId: videoId,
            host: 'https://www.youtube.com',
            height: videoHeight,
            width: videoWidth,
            playerVars: playerVars,
            events: {
              onReady: function onReady() {
                if (typeof $el.data('video-player-btn') !== 'string') {
                  return;
                }

                var $playButton = $($el.data('video-player-btn')); // eslint-disable-next-line no-unused-vars

                $playButton.click(function (evt) {
                  $playButton.hide();
                  $el.css('diplay', 'inline');
                  player.playVideo();
                });
              } // onStateChange(event) { if (event.data==yt.PlayerState.PAUSED) { } },

            }
          });
          console.debug("[YT Player] Initialized. id=".concat(videoId, " height=").concat(videoHeight, " width=").concat(videoWidth, " vars=").concat(JSON.stringify(playerVars)), el);
        }

        var options = {
          root: document.documentElement
        };

        if ($(el).is(':visible')) {
          initializePlayer();
        } else if (window.IntersectionObserver) {
          // eslint-disable-next-line no-unused-vars
          var observer = new window.IntersectionObserver(function (entries, _) {
            entries.forEach(function (entry) {
              if (entry.intersectionRatio > 0) {
                // visible
                initializePlayer();
              }
            });
          }, options);
          observer.observe(el);
        }
      });
    });
  });
})["catch"](function (err) {
  console.error("[YT Player] Failed to load IFRAME API: ".concat(err));
});